var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialTwitter20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Commbank-Footer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "md---768---977---New-footer",
    transform: "translate(-504.000000, -352.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-icon",
    transform: "translate(504.000000, 352.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,22 C17.0749647,22 22,17.0756115 22,11 C22,4.92568203 17.0749647,0 11,0 C4.92503528,0 0,4.92568203 0,11 C0,17.0756115 4.92503528,22 11,22",
    id: "Fill-1",
    fill: "#78CBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9086194,7.51420304 C16.4894261,7.70036235 16.0374206,7.82625426 15.5646563,7.88250384 C16.0481348,7.5932203 16.4191142,7.1345184 16.59322,6.58809395 C16.1412145,6.85661871 15.640995,7.05081367 15.106624,7.15527717 C14.6807344,6.7005931 14.0720336,6.41666667 13.398378,6.41666667 C12.1066466,6.41666667 11.0586635,7.46464984 11.0586635,8.75705082 C11.0586635,8.94053158 11.0787526,9.11865524 11.1189309,9.29008252 C9.17363303,9.1923154 7.44931567,8.26151884 6.29419044,6.84389559 C6.09262946,7.19143761 5.97745176,7.5932203 5.97745176,8.0217885 C5.97745176,8.83338953 6.39061829,9.54990199 7.01873856,9.96976489 C6.63503609,9.95838105 6.27410131,9.85190864 5.95803226,9.67780281 L5.95803226,9.70659723 C5.95803226,10.8409637 6.76494583,11.7871619 7.83636632,12.001446 C7.63949281,12.0563563 7.43324436,12.0838115 7.21896026,12.0838115 C7.06829175,12.0838115 6.92097144,12.0697491 6.77900822,12.0422939 C7.07632741,12.9717512 7.94082982,13.6494247 8.96537567,13.6668353 C8.16381921,14.2949555 7.15467503,14.6692831 6.05847793,14.6692831 C5.86964007,14.6692831 5.68281112,14.6585689 5.5,14.6371404 C6.53592969,15.3000819 7.76605435,15.6878022 9.08791939,15.6878022 C13.3936905,15.6878022 15.7474674,12.1219808 15.7474674,9.02892377 C15.7474674,8.92713882 15.7454585,8.82535387 15.7407711,8.72624748 C16.1981337,8.3954464 16.5958985,7.98361915 16.9086194,7.51420304",
    id: "Fill-4",
    fill: "#FEFEFE"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter20);
export default __webpack_public_path__ + "static/media/socialTwitter20.509965b7a2e9eb92c3e8395e4bd178d3.svg";
export { ForwardRef as ReactComponent };